<template>
  <base-container :isLoading="conLoading" ref="container">
    <ArtisanGrid
      ref="holiday"
      metaKey="HolidayManager"
      :handleQuery="handleQuery"
      @syncHoliday="syncHoliday"
      @addHoliday="addHoliday"
      @editHoliday="editHoliday"
    >
      <template #holidayDate="{ row }">
        <div>{{ row.startDate }} ~ {{ row.endDate }}</div>
      </template>

      <template #ajustDates="{ row }">
        <div v-if="row.ajustDates == ''">无调休</div>
        <div v-else>{{ getAjustDates(row.ajustDates) }}</div>
      </template>

      <template #dayCount="{ row }">
        <div>{{ row.dayCount + "天" }}</div>
      </template>

      <template slot="gridBtnAfter">
        <el-date-picker
          style="
            position: absolute;
            left: 50%;
            transform: translate(-50%);
            margin-top: 3px;
          "
          size="mini"
          value-format="yyyy"
          v-model="year"
          @change="queryHoliday"
          type="year"
          placeholder="选择年"
        >
        </el-date-picker>
      </template>
    </ArtisanGrid>

    <artisan-dialog
      ref="dialog"
      :title="title"
      width="60%"
      :visible.sync="isShow"
      v-loading="isLoading"
    >
      <el-form
        ref="dicTypeForm"
        label-width="100px"
        :rules="rules"
        size="mini"
        :model="formData"
      >
        <el-row style="margin-top: 20px">
          <el-col :span="12">
            <el-form-item label="年份" prop="year">
              <el-date-picker
                style="width: 100%"
                v-model="formData.year"
                type="year"
                value-format="yyyy"
                placeholder="请选择年份"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="节日" prop="type">
              <el-select
                multiple
                size="mini"
                v-model="formData.type"
                clearable
                placeholder="请选择节日"
              >
                <el-option
                  v-for="item in types"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="放假时间" prop="holidayDate">
              <el-date-picker
                style="width: 100%"
                @blur="getDayCount"
                v-model="formData.holidayDate"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="放假天数" prop="dayCount">
              <el-input
                size="mini"
                disabled
                v-model="formData.dayCount"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="调休时间" prop="justDates">
              <el-date-picker
                @input="$forceUpdate()"
                style="width: 100%"
                value-format="yyyy-MM-dd"
                type="dates"
                v-model="formData.justDates"
                placeholder="选择调休时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <el-button type="primary" size="mini" @click="save">保存</el-button>
      </template>
    </artisan-dialog>
  </base-container>
</template>

<script>
import { getWeekLabel } from "@/util/util";
import { sync, add, edit } from "@/api/basis/holiday";
import moment from "moment";
import { loadEnums } from "@/api/sys/dicType";
export default {
  data() {
    return {
      conLoading: false,
      isShow: false,
      isLoading: false,
      title: "",
      year: moment().format("yyyy"),
      formData: {
        year: "",
        type: "",
        startDate: "",
        endDate: "",
        ajustDates: "",
        dayCount: "",
        holidayDate: "",
        justDates: "",
      },
      rules: {
        year: [{ required: true, message: "请选择年份", trigger: "change" }],
        type: [{ required: true, message: "请选择节日", trigger: "change" }],
        holidayDate: [
          { required: true, message: "请选择放假时间", trigger: "change" },
        ],
      },
      types: [],
      isEdit: false,
    };
  },
  created() {
    loadEnums("HolidayTypeOption").then((res) => {
      this.types = res.data.data.HolidayTypeOption;
    });
  },
  methods: {
    getWeekLabel,
    handleQuery(param) {
      param.year = this.year;
      return param;
    },
    getAjustDates(value) {
      let label = "";
      let arr = value.split(",");
      arr.forEach((e) => {
        label =
          label == ""
            ? e + "(" + getWeekLabel(moment(e).isoWeekday()) + ")"
            : label +
              "、" +
              e +
              "(" +
              getWeekLabel(moment(e).isoWeekday()) +
              ")";
      });
      return label;
    },
    getDayCount() {
      this.formData.dayCount =
        moment(this.formData.holidayDate[1]).diff(
          moment(this.formData.holidayDate[0]),
          "days"
        ) + 1;
    },
    syncHoliday() {
      this.$refs.container
        .confirm({
          msg: "确认同步今年的节假日？",
        })
        .then(() => {
          this.conLoading = true;
          sync().then((res) => {
            this.conLoading = false;
            this.$refs.holiday.reload();
          });
        });
    },
    addHoliday() {
      this.title = "新增节假日";
      this.formData = {
        year: this.year,
        type: "",
        startDate: "",
        endDate: "",
        ajustDates: "",
        dayCount: "",
        holidayDate: "",
        justDates: "",
      };
      this.$refs.dicTypeForm.resetFields();
      this.isEdit = false;
      this.isShow = true;
    },
    editHoliday(row) {
      this.title = "编辑节假日";
      this.formData = Object.assign({}, row);
      this.formData.holidayDate = [
        this.formData.startDate,
        this.formData.endDate,
      ];
      if (this.formData.type != "") {
        this.formData.type = this.formData.type.split(",");
      }
      if (this.formData.ajustDates != "") {
        this.formData.justDates = this.formData.ajustDates.split(",");
      }
      this.isEdit = true;
      this.isShow = true;
    },
    save() {
      this.$refs.dicTypeForm.validate((valid) => {
        if (valid) {
          this.$refs.container
            .confirm({
              msg: "确认保存？",
            })
            .then(() => {
              this.isLoading = true;
              this.formData.startDate = this.formData.holidayDate[0];
              this.formData.endDate = this.formData.holidayDate[1];
              if (
                this.formData.justDates != null &&
                this.formData.justDates != ""
              ) {
                this.formData.ajustDates = this.formData.justDates.join(",");
              } else {
                this.formData.ajustDates = "";
              }
              if (this.formData.type != "") {
                this.formData.type = this.formData.type.join(",");
              }
              if (this.isEdit) {
                edit(this.formData)
                  .then(() => {
                    this.isLoading = false;
                    this.isShow = false;
                    this.$refs.holiday.reload();

                    this.$message({
                      type: "success",
                      message: "编辑成功！",
                    });
                  })
                  .catch(() => {
                    this.isLoading = false;
                    this.isShow = false;
                    this.$refs.holiday.reload();
                  });
              } else {
                add(this.formData)
                  .then(() => {
                    this.isLoading = false;
                    this.isShow = false;
                    this.$refs.holiday.reload();
                    this.$message({
                      type: "success",
                      message: "保存成功！",
                    });
                  })
                  .catch(() => {
                    this.isLoading = false;
                    this.isShow = false;
                    this.$refs.holiday.reload();
                  });
              }
            });
        }
      });
    },
    queryHoliday() {
      this.$refs.holiday.reload({ year: this.year });
    },
  },
};
</script>

<style>
</style>